export default __webpack_public_path__ + "static/media/ECE_white.c0d65bda.svg";